export enum ProjectResourceType {
    Users = 'users',
    Teams = 'teams',
    Memberships = 'memberships',
    Databases = 'databases',
    Buckets = 'buckets',
    Functions = 'functions',
    Sites = 'sites',
    Deployments = 'deployments',
    Topics = 'topics',
    Providers = 'providers',
    Messages = 'messages',
}
